import { Injectable } from '@angular/core';
import { OverlayConfirmations } from './confirm-lane';

@Injectable({ providedIn: 'root' })
export class OverlayConfirmationsNgService extends OverlayConfirmations {}
